

/* -- opções de assinatura e pagamentos ------------------------------------------------------------------- 
step 0:
    status 3: todas as opções de pagamento para o cliente fazer a assinatura (boleto, pix ou cartão)
    status 4: histórico de pagamentos, informações de pagamento, alteração de cartão, pagamento na tela (pix ou boleto),
              alteração na forma de pagamento e cancelamento de assinatura/conta (link para agents)
step 1:
    status 3: tela de pagamento por pix ou boleto bancário (dependendo da escolha)

step 2: 
    status 3: conclusão de pagamento por qualquer forma (boleto, pix ou cartão) e de qualquer operação

step 4:
    status 3: tela de pagamento por cartão de crédito

**** fazer ****
step 3:
    status 4: tela para alteração do cartão de crédito

step 5:
    status 4: tela para alteração da forma de pagamento (instruções sobre as regras)
-- --------------------------------------------------------------------------------------------------------- */



import "./billing.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";

/* formulário */
import { useForm } from "react-hook-form";

/* banco de dados */
import { db, auth } from "../../services/firebaseConnection";
import { collection, getDocs, where, query, limit, addDoc, onSnapshot, doc, updateDoc, Timestamp, orderBy, deleteDoc } from "firebase/firestore";

/* funções auxiliares */
import { firstName, expiryDate, showError, clearError, formError, validarCPFouCNPJ, wait, registerLog, formatTimestamp, db_basic } from "../../services/functions/functions.ts";

/* validação de campos */
import { maskdocumento, maskcartao, maskvencimento } from "../../services/masks/masks.ts";

/* imagens */
import icon_success from "../../assets/sucesso.png";
import icon_whats from "../../assets/whats_icon.png";
import icon_web from "../../assets/web_icon.png";
import image_pix from "../../assets/billing_pix.png";
import image_boleto from "../../assets/billing_boleto.png";
import image_cartao from "../../assets/billing_credit.png";
import image_desenvolvimento from "../../assets/desenvolvimento.png";

/* código de barras */
import JsBarcode from "jsbarcode";
import { Navigate } from "react-router-dom";

/* links */
import { useNavigate } from "react-router-dom";

export default function Billing() {

    const [basic, setBasic] = useState(null);
    const [loadBasic, setLoadBasic] = useState(true);

    const [step, setStep] = useState(0);
    const [prevStep, setPrevStep] = useState(0);
    const [error, setError] = useState("0");
    const [cep, setCep] = useState("");
    const [numero, setNumero] = useState("");
    const [idClienteAsaas, setIdClienteAsaas] = useState([]);
    const [idPaymentAsaas, setIdPaymentAsaas] = useState([]);
    const [idSubscriptionAsaas, setIdSubscriptionAsaas] = useState([]);
    const [idBillingAsaas, setIdBillingAsaas] = useState([]);

    const [historyPayment, setHistoryPayment] = useState({parcelas: [],});
    const [infoPlan, setInfoPLan] = useState([]);

    const [plans, setPlans] = useState([]);

    const { handleSubmit, register, getValues, setValue } = useForm();

    const [isPending, startTransition] = useTransition();
    const [isPaying, setIsPaying] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);

    const [billingData, setBillingData] = useState(null);
    const [billingDocId, setBillingDocId] = useState(null);

    const [payment, setPayment] = useState("pix");


    /* refs para tratamento de erros */
    const refDocumento = useRef(null);
    const refLabelDocumento = useRef(null);
    const refErrorDocumento = useRef(null);

    //cartão de crédito
    const refNumeroCartao = useRef(null);
    const refLabelNumeroCartao = useRef(null);
    const refErrorNumeroCartao = useRef(null);

    const refVencimentoCartao = useRef(null);
    const refLabelVencimentoCartao = useRef(null);

    const refNomeCartao = useRef(null);
    const refLabelNomeCartao = useRef(null);
    const refErrorNomeCartao = useRef(null);

    const refCodigoCartao = useRef(null);
    const refLabelCodigoCartao = useRef(null);

    const refCheckBox = useRef(null);

    const refErrorCartao = useRef(null);
    const refButtonCartao = useRef(null);
    const refErrorCancelar = useRef(null);
    const refErrorTerms = useRef(null);

    const refError = useRef(null);
    const refButton = useRef(null);
    const refLoad = useRef(null);
    /* -- */

    const navigate = useNavigate();

    function dateToYYYYMMDD(date) {
        return Number(
            `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, "0")}${String(date.getDate()).padStart(2, "0")}`
        );
    }

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {

        const loadBasic = async () => {

            const uid = auth.currentUser.uid;
            const bbd = await db_basic(uid);
            setBasic(bbd);

            //carrega informações
            try {

                const aid = bbd.agent.id;
                const cod = bbd.agent.plano;

                const planQuery = query(collection(db, "plans"), where("codigo", ">=", cod), where("codigo", "<=", cod + "\uf8ff"), where("data_termino_vigencia", "==", expiryDate()));

                const cepQuery = query(collection(db, "medical"), where("id_agent", "==", aid), limit(1));

                //executa todas ao mesmo tempo
                const [planSnap, cepSnap] = await Promise.all([getDocs(planQuery), getDocs(cepQuery),]);

                setValue("responsavel", bbd.client.responsavel || "");
                setValue("email", bbd.client.email || "");
                setValue("telefone", bbd.client.telefone || "");
                    
                //plans
                if(!planSnap.empty) {
                    const plans = planSnap.docs.map((doc) => ({
                        id: doc.id,
                        codigo: doc.data().codigo,
                        ramo: doc.data().ramo,
                        atendimento: doc.data().atendimento,
                        valor: doc.data().valor,
                    }));
                    setPlans(plans);
                } else {
                    setPlans([]);
                }

                //cep
                if(!cepSnap.empty) {
                    const cepData = cepSnap.docs[0].data();
                    setCep(cepData.cep);
                    setNumero(cepData.numero);
                }

                const billingQuery = query(collection(db, "billings"), where("id_agent", "==", aid), orderBy("data_criacao", "desc"), limit(1));
                const atplanQuery = query(collection(db, "plans"), where("codigo", "==", cod), limit(1));

                const [billingSnap, atplanSnap] = await Promise.all([getDocs(billingQuery), getDocs(atplanQuery),]);

                if(!billingSnap.empty) {

                    const hb = billingSnap.docs[0].data();
                    const limite = new Date();
                    limite.setDate(limite.getDate() + 5);

                    hb.parcelas = hb.parcelas.filter(parcela => {return parcela.vencimento && parcela.vencimento.toDate() <= limite;}).sort((a, b) => {return b.vencimento.toDate() - a.vencimento.toDate();});
                    setHistoryPayment(hb);
    
                }                
                
                if(!atplanSnap.empty) {
                    const pl = atplanSnap.docs[0].data();
                    setInfoPLan(pl);
                } 

            }
            catch(erro) {
                console.log(erro);
            }
            setLoadBasic(false);
        };

        loadBasic();

    }, []);


    const handleChange = (event) => { setPayment(event.target.value); };


    async function create_payment(e) {

        e.preventDefault();
        formError(refError, "", false);

        let dc = getValues("documento");
        if(dc.length !== 14 && dc.length !== 18) {
            showError(refDocumento, refLabelDocumento, refErrorDocumento, "Insira um CPF ou CNPJ com todos os dígitos.", setError, "documento");
            return;
        }

        if(!validarCPFouCNPJ(dc)) {
            showError(refDocumento, refLabelDocumento, refErrorDocumento, "Esse número de CPF ou CNPJ é inválido.", setError, "documento");
            return;
        }

        setIsPaying(true);

        try {

            const uid = basic.client.id;
            const aid = basic.agent.id;
            const nom = basic.client.empresa;
    
            let id_client_asaas = [];
            let id_payment_asaas = [];
            let id_subscription_assas = [];
            let id_billing_assas = [];

            refButton.current.innerHTML = "AGUARDE ... verificando cliente";

            //cria ou retorna cliente asaas
            const resClientAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/upsertclient", 
            { method: "POST", headers: {"Content-Type": "application/json"} ,
                body: JSON.stringify(
                {
                    documento: getValues("documento"),
                    nome: getValues("responsavel"),
                    email: getValues("email"),
                    telefone: getValues("telefone"),
                    empresa: nom,
                    cep: cep.replace("-", ""),
                    numero: numero,
                    idagent: aid,
                    idclient: uid
                })
            });

            if(!resClientAsaas.ok) {
                setIsPaying(false);
                const errorData = await resClientAsaas.json();
                formError(refError, JSON.stringify(errorData), true);
                refButton.current.innerHTML = "FAZER ASSINATURA";
                return;            
            } else {
                const dataClientAsaas = await resClientAsaas.json();
                id_client_asaas = dataClientAsaas;
                setIdClienteAsaas(id_client_asaas);
            }

            wait(500);
            registerLog(uid, "/billing/step1/pagamento=" + payment);

            if(payment === "credito") {

                setIsPaying(false);
                refButton.current.innerHTML = "FAZER ASSINATURA";
                setStep(4);
                window.scrollTo(0, 0);

            } else {

                refButton.current.innerHTML = "AGUARDE ... criando assinatura";

                //cria assinatura para pix ou boleto e resgata a primeira fatura
                const amanha = new Date(Date.now() + 24 * 60 * 60 * 1000);
                const dataFormatada = amanha.toISOString().split('T')[0];

                const resCreateSubscriptionAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/createsubscription", 
                { method: "POST", headers: {"Content-Type": "application/json"} ,
                    body: JSON.stringify(
                    {
                        cliente: id_client_asaas.cliente.id,
                        pagamento: payment.toUpperCase(),
                        valor: plans[0].valor,
                        vencimento: dataFormatada,
                        idagent: aid,
                        descricao: "WINNERS-AI Assinatura - Plano: " + plans[0].ramo + ", Código do Plano: " + plans[0].codigo + ", Valor: R$ " + plans[0].valor.toFixed(2) + ", id_agent = " + aid
                    })
                });
                
                if(!resCreateSubscriptionAsaas.ok) {
                    setIsPaying(false);
                    const errorData = await resCreateSubscriptionAsaas.json();
                    formError(refError, JSON.stringify(errorData), true);
                    refButton.current.innerHTML = "FAZER ASSINATURA";
                    return;            
                } else {
                    const dataCreateSubscriptionAsaas = await resCreateSubscriptionAsaas.json();
                    id_subscription_assas = dataCreateSubscriptionAsaas.assinatura;
                    id_payment_asaas = dataCreateSubscriptionAsaas.primeira_fatura;
                    setIdSubscriptionAsaas(id_subscription_assas);
                    setIdPaymentAsaas(id_payment_asaas);
                }

                wait(500);
                
                //resgata informações da cobrança
                const resPaymentInfoAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/paymentinfo", 
                { method: "POST", headers: {"Content-Type": "application/json"} ,
                    body: JSON.stringify(
                    {
                        idcobranca: id_payment_asaas.id
                    })
                });
                
                if(!resPaymentInfoAsaas.ok) {
                    setIsPaying(false);
                    const errorData = await resPaymentInfoAsaas.json();
                    formError(refError, JSON.stringify(errorData), true);
                    refButton.current.innerHTML = "FAZER ASSINATURA";
                    return;            
                } else {
                    const dataPaymentInfoAsaas = await resPaymentInfoAsaas.json();
                    id_billing_assas = dataPaymentInfoAsaas.informacoes;
                    setIdBillingAsaas(id_billing_assas);
                }

                wait(500);

                refButton.current.innerHTML = "AGUARDE ... registrando dados";

                const rb = await registrar_billing(id_client_asaas.cliente.id, id_subscription_assas.id, id_payment_asaas.id, payment.toUpperCase());
                if(rb.erro) {
                    setIsPaying(false);
                    formError(refError, "Erro ao registar dados: " + rb.status, true);
                    refButton.current.innerHTML = "FAZER ASSINATURA";
                    return;            
                }
                
                refButton.current.innerHTML = "FAZER ASSINATURA";
                setIsPaying(false);

                registerLog(uid, "/billing/step2/id_agent=" + aid + ", customer_asaas=" + id_client_asaas.cliente.id + ", subscription_assas=" + id_subscription_assas.id + ", cobrança_asaas=" + id_payment_asaas.id);

                setBillingData(id_billing_assas);
                setBillingDocId(rb.status);
            
                setStep(1);
                window.scrollTo(0, 0);
                
            }
        
        }
        catch(erro) {

            setIsPaying(false);
            formError(refError, erro, true);
            refButton.current.innerHTML = "FAZER ASSINATURA";

        }

    }


    async function create_payment_card(e) {

        e.preventDefault();
        formError(refErrorCartao, "", false);

        let cn = getValues("card_number");
        if(cn.length < 19) {
            showError(refNumeroCartao, refLabelNumeroCartao, refErrorNumeroCartao, "Insira um número de cartão com todos os dígitos", setError, "card_number");
            return;
        }

        let cv = getValues("card_expiry");
        if(cv.length < 5) {
            showError(refVencimentoCartao, refLabelVencimentoCartao, refErrorNumeroCartao, "Insira uma data de validade do cartão correta", setError, "card_expiry");
            return;
        }

        let cm = getValues("card_name");
        if(cm.length < 3) {
            showError(refNomeCartao, refLabelNomeCartao, refErrorNomeCartao, "Insira um nome impresso de cartão válido", setError, "card_name");
            return;
        }

        let cc = getValues("card_code");
        if(cc.length < 3) {
            showError(refCodigoCartao, refLabelCodigoCartao, refErrorNomeCartao, "Insira um código de segurança com 3 dígitos", setError, "card_code");
            return;
        }

        setIsPaying(true);

        try {

            let uid = basic.client.id;
            let aid = basic.agent.id;
            
            let id_payment_asaas = [];
            let id_subscription_assas = [];

            refButtonCartao.current.innerHTML = "AGUARDE ... criando assinatura";

            const resip = await fetch("https://api.ipify.org?format=json");
            const dataip = await resip.json();
            const ip = dataip.ip;

            //cria assinatura para cartão de crédito e busca a primeira fatura
            const amanha = new Date(Date.now() + 24 * 60 * 60 * 1000);
            const dataFormatada = amanha.toISOString().split('T')[0];

            const resCreateSubscriptionAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/createsubscription", 
            { method: "POST", headers: {"Content-Type": "application/json"} ,
                body: JSON.stringify(
                {
                    cliente: idClienteAsaas.cliente.id,
                    pagamento: "CREDIT_CARD",
                    valor: plans[0].valor,
                    vencimento: dataFormatada,
                    idagent: aid,
                    descricao: "WINNERS-AI Assinatura - Plano: " + plans[0].ramo + ", Código do Plano: " + plans[0].codigo + ", Valor: R$ " + plans[0].valor.toFixed(2)
                })
            });
            
            if(!resCreateSubscriptionAsaas.ok) {
                setIsPaying(false);
                const errorData = await resCreateSubscriptionAsaas.json();
                formError(refErrorCartao, JSON.stringify(errorData), true);
                refButtonCartao.current.innerHTML = "FAZER PAGAMENTO";
                return;            
            } else {
                const dataCreateSubscriptionAsaas = await resCreateSubscriptionAsaas.json();
                id_subscription_assas = dataCreateSubscriptionAsaas.assinatura;
                id_payment_asaas = dataCreateSubscriptionAsaas.primeira_fatura;
                setIdSubscriptionAsaas(id_subscription_assas);
                setIdPaymentAsaas(id_payment_asaas);
            }

            wait(500);
            refButtonCartao.current.innerHTML = "AGUARDE ... processando pagamento";

            const resPaymentCardAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/paymentcard", 
            { method: "POST", headers: {"Content-Type": "application/json"} ,
                body: JSON.stringify(
                {
                    idcobranca: id_payment_asaas.id,
                    cartao_nome: getValues("card_name"),
                    cartao_numero: getValues("card_number"),
                    cartao_mes: getValues("card_expiry").slice(0, 2),
                    cartao_ano: "20" + getValues("card_expiry").slice(-2),
                    cartao_codigo: getValues("card_code"),
                    info_nome: getValues("responsavel"),
                    info_email: getValues("email"),
                    info_documento: getValues("documento"),
                    info_cep: cep,
                    info_numero: numero,
                    info_telefone: getValues("telefone"),
                    ip_remoto: ip
                })
            });

            if(!resPaymentCardAsaas.ok) {
                setIsPaying(false);
                const errorData = await resPaymentCardAsaas.json();
                formError(refErrorCartao, JSON.stringify(errorData), true);
                refButtonCartao.current.innerHTML = "FAZER PAGAMENTO";
                return;            
            } else {
                const dataPaymentCardAsaas = await resPaymentCardAsaas.json();
            }
            
            wait(500);
            refButtonCartao.current.innerHTML = "AGUARDE ... registrando dados";

            const rb = await registrar_billing(idClienteAsaas.cliente.id, id_subscription_assas.id, id_payment_asaas.id, "CREDIT_CARD");
            if(rb.erro) {
                setIsPaying(false);
                formError(refErrorCartao, "Erro ao registar dados: " + rb.status, true);
                refButtonCartao.current.innerHTML = "FAZER PAGAMENTO";
                return;            
            }

            registerLog(uid, "/billing/step2/id_agent=" + aid + ", customer_asaas=" + idClienteAsaas.cliente.id + ", subscription_assas=" + id_subscription_assas.id + ", cobrança_asaas=" + id_payment_asaas.id);

            refButtonCartao.current.innerHTML = "AGUARDE ... recebendo pagamento";

            setBillingDocId(rb.status);

        }
        catch(erro) {

            setIsPaying(false);
            formError(refErrorCartao, erro, true);
            refButtonCartao.current.innerHTML = "FAZER PAGAMENTO";

        }

    }



    async function registrar_billing(cliente_asaas, assinatura_asaas, cobranca_assas, tipo_cobranca) {

        try {

            //registra os dados no firebase
            let uid = basic.client.id;
            let aid = basic.agent.id;
            const hoje = new Date();
            const amanha = new Date(Date.now() + 24 * 60 * 60 * 1000);
            amanha.setHours(23, 59, 59, 0);

            //checa se houve outra conta billing criada anteriormente para o mesmo agente e
            //exclui essa conta
            const billingQuery = query(collection(db, "billings"), where("id_agent", "==", aid));

            const billingSnap = await getDocs(billingQuery);

            for (const billingDoc of billingSnap.docs) {

                let id_ass = billingDoc.data().id_subscription_asaas;

                const resCancellAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/cancellsubscription", 
                { method: "POST", headers: {"Content-Type": "application/json"} ,
                    body: JSON.stringify(
                    {
                        assinatura: id_ass
                    })
                });
                    
                if(!resCancellAsaas.ok) {

                    const errorData = await resCancellAsaas.json();
                    formError(refError, JSON.stringify(errorData), true);
                    return;    

                } 

                await deleteDoc(billingDoc.ref);

            }

            const docbilling = await addDoc(collection(db, "billings"), {
                id_client: uid,
                id_agent: aid,
                id_client_asaas: cliente_asaas,
                id_subscription_asaas: assinatura_asaas,
                status: "ACTIVE",
                data_criacao: hoje,
                parcelas: [{id_payment_asaas: cobranca_assas, mensalidade: 1, vencimento: Timestamp.fromDate(amanha), valor: plans[0].valor, status: "PENDING", tipo: tipo_cobranca, data_pagamento: null, consumo: 0}],
                dia_vencimento: amanha.getDate(),
                data_encerramento: null,
            });

            const clientquery = query(collection(db, "client"), where("id", "==", uid), limit(1));
            const clientdados = await getDocs(clientquery);

            const clientdoc = clientdados.docs[0];

            await updateDoc(clientdoc.ref, {
                documento: getValues("documento"),
            });

            return {erro: false, status: docbilling.id};

        }
        catch(erro) {
            return {erro: true, status: erro};
        }
        
    }



    function TelaPagamento({data}) {
  
        const svgRef = useRef(null);

        //gera o código de barras do boleto (se houver)
        useEffect(() => {
            if (data?.bankSlip?.barCode) {
                JsBarcode(svgRef.current, data.bankSlip.barCode, {format: "ITF", lineColor: "#000", width: 1.6, height: 70, displayValue: false,});
            }
        }, [data]);

        //se tiver boleto, prioriza ele
        const isBoleto = !!data?.bankSlip;
        const isPix = !!data?.pix && !isBoleto; // só mostra PIX se não houver boleto

        if(!isPix && !isBoleto) {
            return (
                <div className="flex flex-col items-center gap-6">
                    <span className="text-gray-500">Nenhuma informação de pagamento disponível.</span>
                </div>
            );
        }

        return (
            <div className="flex flex-col items-center gap-6">
            {/* PIX */}
            {isPix && (
            <>
            <span className="title_form">Pix QR Code</span>
            <div className="billing_box_pix"><img src={`data:image/png;base64,${data.pix.encodedImage}`} alt="QR Code PIX" className="billing_pix_qrcode" />
            <span className="space_form"></span>
            <span className="billing_pix_payload">{data.pix.payload}</span>
            <div className="billing_box_pix_button">
                <button onClick={() => navigator.clipboard.writeText(data.pix.payload)} className="buttonsearch_form">Copiar código PIX</button>
            </div>
            <span className="space_form"></span>
            </div>
            </>
            )}

            {/* boleto */}
            {isBoleto && (
            <>
            <span className="title_form">Boleto Bancário</span>
            <div className="billing_box_boleto">
                <svg className="billing_boleto_barras" ref={svgRef}></svg>
                <span className="space_form"></span>
                <span className="billing_boleto_digitavel">Linha Digitável</span>
                <span className="billing_boleto_linha">{data.bankSlip.identificationField.replace(/^(\d{5})(\d{5})(\d{5})(\d{6})(\d{5})(\d{6})(\d{1})(\d{14})$/, "$1.$2 $3.$4 $5.$6 $7 $8")}</span>
                <span className="space_form"></span>
                <div className="billing_box_boleto_button"><a href={data.bankSlip.bankSlipUrl} target="_blank" rel="noopener noreferrer" className="billing_boleto_link">Abrir boleto PDF</a></div>
            </div>
            <span className="space_form"></span>
            </>
            )}
        </div>
        );
    }


    useEffect(() => {
  
        if (!billingDocId) return;

        const docRef = doc(db, "billings", billingDocId);

        const unsubscribe = onSnapshot(docRef, (docSnap) => {
            if(docSnap.exists()) {
                const docData = docSnap.data();

                //procura alguma parcela com status = "PAID"
                const parcelas = docData.parcelas || [];
                const parcelaPaga = parcelas.find(p => p.status === "PAID" && p.mensalidade === 1);

                if(parcelaPaga) {
                    setStep(2);
                    window.scrollTo(0, 0);
                }
            }
        });

        return () => unsubscribe();

    }, [billingDocId]);


    
    function direciona_cancelamento() {
        navigate("/agent", { state: { step: 2 } });
    }


    //deixar a melhor opção selecionada na alteração de pagamento
    useEffect(() => {
        
        if (step !== 5) return;

        const tipoAtual = historyPayment?.parcelas?.[historyPayment.parcelas.length - 1]?.tipo;

        if(tipoAtual === "PIX" || tipoAtual === "BOLETO") {setPayment("credito");} else {setPayment("pix");}
        
    }, [step, historyPayment]);





    return(
        <div className="context">
                            
            <Header access={1}></Header>
                    
            <div className="content">

                {/* tela inicial - opções de pagamento para não assinantes (agents status 3) e configurações de pagamentos (agentes status 4) */}
                { step === 0 && (
                <>
                
                { loadBasic ? (
                <>
                <div className="border_form agent_border_form">
                    <span ref={refLoad} className="load_form">aguarde carregando formulário ...</span>
                </div>
                </>
                ) : (
                <>
                    { basic?.agent?.status === 3 && (
                    <>
                    <span className="ft_topico">Faça a sua assinatura</span>
                    <span className="ft_descricao">Fazendo a sua assinatura, você garante o número de linha que você já testou, pode alterar seu agente e as respectivas configurações quando desejar e acompanhar a performance do agente mais detalhadamente.</span>
                    <div className="space"></div>

                    <div className="border_form billing_border_form">
                        <form className="form">

                            <span className="title_form">Assinatura</span>
                            <span className="subtitle_form">{firstName(basic.client.responsavel)}, já temos alguns de seus dados.<br />Agora você só precisa informar o CPF ou CNPJ, seu plano e a forma de pagamento.</span>
                            <span className="space_form"></span>

                            <label for="inp" className="inp">
                            <input type="text" placeholder="&nbsp;" disabled={true} {...register("responsavel")}></input>
                            <span className="label">Responsável</span>
                            <span className="focus-bg"></span>
                            </label>
                            <span className="space_form"></span>

                            <div className="billing_box">

                                <div className="billing_box01a">
                                    <label for="inp" className="inp">
                                    <input type="text" placeholder="&nbsp;" disabled={true} {...register("email")}></input>
                                    <span className="label">Email</span>
                                    <span className="focus-bg"></span>
                                    </label>
                                </div>

                                <div className="billing_box01b"></div>

                                <div className="billing_box01c">
                                    <label for="inp" className="inp">
                                    <input type="text" placeholder="&nbsp;" disabled={true} {...register("telefone")}></input>
                                    <span className="label">Telefone</span>
                                    <span className="focus-bg"></span>
                                    </label>
                                </div>

                            </div>
                            <span className="space_form"></span>

                            <span ref={refErrorDocumento} className="error_form"></span>
                            <label for="inp" className="inp" ref={refLabelDocumento}>
                            <input type="text" placeholder="&nbsp;" maxLength={18} {...register("documento")} ref={(el) => {refDocumento.current = el; register("documento").ref(el);}} onClick={() => clearError(refDocumento, refLabelDocumento, refErrorDocumento, error, setError)} onChange={(e) => {if (error === "0") {setValue("documento", maskdocumento(e.target.value));} else {clearError(refDocumento, refLabelDocumento, refErrorDocumento, error, setError);}}}></input>
                            <span className="label">CPF ou CNPJ</span>
                            <span className="focus-bg"></span>
                            </label>
                            <span className="space_form"></span>

                           <div className="billing_box_plans">
                                <span className="billing_box_plans_title">Planos Disponíveis:</span>
                                { plans.map((item, index) => (
                                <>
                                <div className="billing_box_plans_item" key={index}>
                                    <span className="billing_box_plans_itemA"><input type="radio" name="plans" value={item.codigo} className="radio_custom" checked={true}></input></span>
                                    <span className="billing_box_plans_itemB">{item.ramo}</span>
                                    <span className="billing_box_plans_itemC">{item.atendimento === "W" ? (<><img className="billing_image_whats" src={icon_whats}></img></>) : (<><img className="billing_image_whats" src={icon_whats}></img>&nbsp;<img className="billing_image_whats" src={icon_web}></img></>)}</span>
                                    <span className="billing_box_plans_itemD">R$ {item.valor.toFixed(2)}</span>
                                </div>
                                </>
                                ))}
                            </div>
                            <span className="space_form"></span>

                            <div className="billing_box_plans">
                                <span className="billing_box_payment_title">Pagamentos Disponíveis:</span>
                                <div className="billing_box_payment_group">
                                    <div className="billing_box_payment">
                                        <div className="billing_box_payment_item">
                                            <div className="billing_box_payment_item_option">
                                                <input type="radio" name="payment" value="pix" className="radio_custom" checked={payment === "pix"} onChange={handleChange}></input>
                                                <span className="billing_box_payment_item_text">Pix</span>
                                            </div>
                                            <div className="billing_box_payment_item_image"><img className="billing_image_payment" src={image_pix}></img></div>
                                        </div>
                                    </div>
                                    <div className="billing_box_space"><span className="billing_box_space_line"></span></div>
                                    <div className="billing_box_payment">
                                        <div className="billing_box_payment_item">
                                            <div className="billing_box_payment_item_option">
                                                <input type="radio" name="payment" value="boleto" className="radio_custom" checked={payment === "boleto"} onChange={handleChange}></input>
                                                <span className="billing_box_payment_item_text">Boleto</span>
                                            </div>
                                            <div className="billing_box_payment_item_image"><img className="billing_image_payment" src={image_boleto}></img></div>
                                        </div>

                                    </div>
                                    <div className="billing_box_space"><span className="billing_box_space_line"></span></div>
                                    <div className="billing_box_payment">
                                        <div className="billing_box_payment_item">
                                            <div className="billing_box_payment_item_option">
                                                <input type="radio" name="payment" value="credito" className="radio_custom" checked={payment === "credito"} onChange={handleChange}></input>
                                                <span className="billing_box_payment_item_text">Cartão de Crédito</span>
                                            </div>
                                            <div className="billing_box_payment_item_image"><img className="billing_image_payment" src={image_cartao}></img></div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <span className="space_form"></span>
                            <span ref={refError} className="error_form"></span>
                            <span className="space_form"></span>

                            <button type="button" name="bt1" ref={refButton} className={isPaying ? "button_disabled_form" : "button_form"} onClick={create_payment} disabled={isPaying}>FAZER ASSINATURA</button>
                            
                        </form>
                    </div>

                    </>
                    )}
                    
                    
                    { basic?.agent?.status === 4 && (
                    <>
                    <span className="ft_topico">Gerencie seus pagamentos</span>
                    <span className="ft_descricao">Você é nosso assinante e aqui você poderá ver seu histórico de pagamentos e gerenciar sua conta.</span>
                    <div className="space"></div>

                    <div className="billing_subscriber_box">
                        <div className="billing_subscriber_boxA">
                            <span className="title_form">Histórico de lançamentos</span>
                            <span className="space_form"></span>
                            <div className="billing_subscriber_history_box">
                                <div class="billing_subscriber_history_scroll">

                                { historyPayment.parcelas?.map((item, index) => {

                                    const hoje = new Date();
                                    const vencimento = item.vencimento?.toDate ? item.vencimento.toDate() : new Date(item.vencimento);

                                    const text_vencimento = vencimento.toLocaleDateString("pt-BR", { month: "short", year: "2-digit" }).replace(" de ", "/").replace(".", "").replace(/^./, c => c.toUpperCase());

                                    let status = "";
                                    if (item.data_pagamento) {
                                        status = "Pago";
                                    } else {
                                        if (hoje <= vencimento) {
                                            status = "A vencer";
                                        } else {
                                            status = "Em atraso";
                                        }
                                    }

                                    let consumo = `${item.consumo} - R$ ${((item.consumo / 1000) * 2).toFixed(2)}`;
                                    let valor = (item.valor + ((item.consumo / 1000) * 2)).toFixed(2);
                                
                                    return (
                                    <>
                                        <div className="billing_subscriber_history_group">
                                            <div className="billing_subscriber_history_item_line">
                                                <span className="billing_subscriber_history_item_title">Mensalidade:&nbsp;</span>
                                                <span className="billing_subscriber_history_item_text">{item.mensalidade === 1 ? "1 (Adesão)" : item.mensalidade + " (" + text_vencimento + ")"}</span>
                                            </div>
                                            <div className="billing_subscriber_history_item_line">
                                                <span className="billing_subscriber_history_item_title">Data de Vencimento:&nbsp;</span>
                                                <span className="billing_subscriber_history_item_text">{formatTimestamp(item.vencimento)}</span>
                                            </div>
                                            <div className="billing_subscriber_history_item_line">
                                                <span className="billing_subscriber_history_item_title">Data de Pagamento:&nbsp;</span>
                                                <span className="billing_subscriber_history_item_text">{formatTimestamp(item.data_pagamento)}</span>
                                            </div>
                                            <div className="billing_subscriber_history_item_line">
                                                <span className="billing_subscriber_history_item_title">Assinatura:&nbsp;</span>
                                                <span className="billing_subscriber_history_item_text">R$ {item.valor.toFixed(2)}</span>
                                            </div>
                                            <div className="billing_subscriber_history_item_line">
                                                <span className="billing_subscriber_history_item_title">Compra de Créditos:&nbsp;</span>
                                                <span className="billing_subscriber_history_item_text">{consumo}</span>
                                            </div>
                                            <div className="billing_subscriber_history_item_line">
                                                <span className="billing_subscriber_history_item_title">Valor Total:&nbsp;</span>
                                                <span className="billing_subscriber_history_item_text" style={{fontWeight: "bold"}}>R$ {valor}</span>
                                            </div>
                                            <div className="billing_subscriber_history_item_line">
                                                <span className="billing_subscriber_history_item_title">Status:&nbsp;</span>
                                                <span className="billing_subscriber_history_item_text" style={{color: status === "Pago" ? "green" : status === "A vencer" ? "blue" : "red"}}>{status}{status !== "Pago" && (<>&nbsp;<a href={`https://www.asaas.com/i/${item.id_payment_asaas.replace("pay_", "")}`} className="billing_subscriber_history_item_boleto" target="_blank" rel="noopener noreferrer">ver boleto</a></>)}</span>
                                            </div>
                                        </div>

                                        {index < historyPayment.parcelas?.length - 1 && (<div className="billing_subscriber_history_space"></div>)}
                                    </>
                                    );
                                })}

                                </div>
                            </div>
                        </div>
                        <div className="billing_subscriber_boxB">
                            <div className="billing_subscriber_line"></div>
                        </div>
                        <div className="billing_subscriber_boxA">
                            <span className="title_form">Informações da assinatura</span>
                            <span className="space_form"></span>
                            <span className="billing_subscriber_boxA_line">
                                <span className="billing_subscriber_boxA_title">Situação Geral:&nbsp;</span>
                                <span className="billing_subscriber_boxA_text">    
                                    {(() => {

                                    const hoje = new Date();

                                    const existeAtraso = historyPayment.parcelas?.some(item => {

                                        const vencimento = item.vencimento?.toDate ? item.vencimento.toDate() : new Date(item.vencimento);
                                        const pagamento = item.data_pagamento ? (item.data_pagamento?.toDate ? item.data_pagamento.toDate() : new Date(item.data_pagamento)) : null;

                                        return !pagamento && hoje > vencimento;

                                    });

                                    return existeAtraso ? "Em atraso" : "Em dia";})()}
                                </span>
                            </span>
                            <span className="billing_subscriber_boxA_line">
                                <span className="billing_subscriber_boxA_title">Data da Assinatura:&nbsp;</span>
                                <span className="billing_subscriber_boxA_text">{historyPayment.data_criacao ? formatTimestamp(historyPayment.data_criacao) : ""}</span>
                            </span>    
                            <span className="billing_subscriber_boxA_line">
                                <span className="billing_subscriber_boxA_title">Dia de Vencimento:&nbsp;</span>
                                <span className="billing_subscriber_boxA_text">{historyPayment.dia_vencimento}</span>
                            </span>    
                            <span className="billing_subscriber_boxA_line">
                                <span className="billing_subscriber_boxA_title">Próximo Vencimento:&nbsp;</span>
                                <span className="billing_subscriber_boxA_text">{formatTimestamp(historyPayment.parcelas[historyPayment.parcelas.length - 1]?.vencimento)}</span>
                            </span>    
                            <span className="billing_subscriber_boxA_line">
                                <span className="billing_subscriber_boxA_title">Forma de Cobrança:&nbsp;</span>
                                <span className="billing_subscriber_boxA_text">{historyPayment.parcelas[historyPayment.parcelas.length - 1]?.tipo}</span>
                            </span>    
                            <span className="space"></span>
                            <span className="billing_subscriber_boxA_line">
                                <span className="billing_subscriber_boxA_title">Plano:&nbsp;</span>
                                <span className="billing_subscriber_boxA_text">{infoPlan.ramo + " (" + infoPlan.codigo + ")"}</span>
                            </span>    
                            <span className="billing_subscriber_boxA_line">
                                <span className="billing_subscriber_boxA_title">Valor Atual:&nbsp;</span>
                                <span className="billing_subscriber_boxA_text">R$ {infoPlan.valor ? infoPlan.valor.toFixed(2) : ""}</span>
                            </span>    
                            <span className="billing_subscriber_boxA_title">Canais de Atendimento:</span>    
                            <div className="billing_subscriber_boxA_canais">
                                { infoPlan.atendimento === "W" ? (<><img className="billing_subscriber_boxA_image" src={icon_whats}></img></>) : (<><img className="billing_subscriber_boxA_image" src={icon_whats}></img>&nbsp;<img className="billing_subscriber_boxA_image" src={icon_web}></img></>) }
                            </div>
                        </div>
                        <div className="billing_subscriber_boxB">
                            <div className="billing_subscriber_line"></div>
                        </div>
                        <div className="billing_subscriber_boxA">
                            <span className="title_form">Alteração de pagamento</span>
                            <span className="space_form"></span>
                            <span className="subtitle_form" style={{textAlign: "center"}}>Altere a forma de pagamento da sua assinatura ou altere seu cartão de crédito.</span>
                            <span className="space_form"></span>
                            <div className="billing_subscriber_cancel">
                                <button type="button" name="bt2" className="button_form" onClick={(e) => {setStep(5); window.scrollTo(0, 0);}}>ALTERAR PAGAMENTO</button>
                            </div>

                            <span className="space"></span>
                            <span className="space"></span>
                            <span className="title_form">Cancelamento de assinatura</span>
                            <span className="subtitle_form" style={{textAlign: "center"}}>Quero cancelar minha assinatura e desativar o meu agente.</span>
                            <span className="space_form"></span>
                            <div className="billing_subscriber_cancel">
                                <button type="button" name="bt3" className="button_form" onClick={direciona_cancelamento}>CANCELAR ASSINATURA</button>
                            </div>
                        </div>
                    </div>
                    </>
                    )}
                </>
                )}
                </>
                )}

                {/* tela de pagamento por pix ou boleto (dependendo da escola) - somente agentes status 3 (testes) */}
                { step === 1 && (
                <>
                <span className="ft_topico">Faça a sua assinatura</span>
                <span className="ft_descricao">Fazendo a sua assinatura, você garante o número de linha que você já testou, pode alterar seu agente e as respectivas configurações quando desejar e acompanhar a performance do agente mais detalhadamente.</span>
                <div className="space"></div>

                <div className="border_form billing_border_form">
                    <form className="form">

                        <span className="title_form">Pagamento {payment.charAt(0).toUpperCase() + payment.slice(1)}</span>
                        { payment === "pix" ? (
                        <>
                        <span className="subtitle_form">Você pode fazer seu pagamento Pix através do QR Code ou copiar o código através do botão abaixo.</span>
                        <span className="billing_payment_aviso">Após pagar, aguarde alguns instantes que iremos detectar seu pagamento.</span>
                        </>) : (
                        <>
                        <span className="subtitle_form">Você pode fazer seu pagamento do Boleto através do código de barras ou copiar os números da linha digitável, ou ainda, abrir o PDF se preferir.</span>
                        <span className="billing_payment_aviso">No pagamento por Boleto, o reconhecimento das transações demoram entre 1-2 dias úteis, você pode pagar e assim que detectarmos o pagamento, já alteraremos o status da sua assinatura.</span>
                        </>
                        )}
                        <span className="space_form"></span>

                        <TelaPagamento data={billingData} />
                    
                    </form>
                </div>
                </>
                )}


                {/* tela de conclusão: recebimento de pagamentos, alteração de pagamentos e encerramento da conta - somente agentes status 4 (assinantes) */}
                { step === 2 && (
                <>
                    { prevStep === 0 && (
                    <>
                    <span className="ft_topico">Pagamento efetuado</span>
                    <span className="main_space"></span>
                    <span className="ft_descricao">Como assinante, você tem acesso total a plataforma e seus respecitvos recursos.</span>
                    <div className="space"></div>
                    <img className="billing_success_image" src={icon_success}></img>
                    <div className="space"></div>
                    <span className="billing_success_01">{firstName(basic.client.responsavel)}, seja bem vindo a winners-ai.com</span>
                    <span className="space"></span>
                    <span className="billing_success_02">{ payment === "credito" ? "Para sua comodidade, suas próximas mensalidades serão lançadas diretamente no seu cartão de crédito" : "Para sua comodidade, enviaremos para seu email o boleto/pix para que você possa pagar as próximas mensalidades" }</span>
                    <span className="space"></span>
                    <span className="billing_success_03">1. Para mais detalhes sobre mensalidades, acesse: Painel do Cliente -&gt; Planos e pagamentos</span>
                    <span className="billing_success_03">2. Você poderá cancelar sua assinatura a qualquer momento (consulte nossos&nbsp;<a href="/terms" target="_blank" rel="noopener noreferrer" className="billing_success_03">Termos de Uso</a>)</span>                    
                    </>
                    )}
                </>
                )}


                {/* tela para a alteração do cartão de crédito - somente agentes status 4 (assinantes) */}
                { step === 3 && (
                <>
                <span className="ft_topico">Altere seu cartão</span>
                <span className="ft_descricao">Alteração do cartão de crédito.</span>
                <div className="space"></div>

                
                </>
                )}


                {/* tela de pagamento por cartão de crédito - somente agentes status 3 (testes) */}
                { step === 4 && (
                <>
                <span className="ft_topico">Faça a sua assinatura</span>
                <span className="ft_descricao">Fazendo a sua assinatura, você garante o número de linha que você já testou, pode alterar seu agente e as respectivas configurações quando desejar e acompanhar a performance do agente mais detalhadamente.</span>
                <div className="space"></div>

                <div className="border_form billing_border_form">
                    <form className="form">
                        <span className="title_form">Cartão de Crédito</span>
                        <span className="subtitle_form">Como você optou por fazer a sua assinatura por cartão de crédito, precisamos que você preencha as informações abaixo.</span>
                        <span className="space_form"></span>

                        <span ref={refErrorNumeroCartao} className="error_form"></span>
                        <div className="billing_box_card">
                            <div className="billing_box_card1a">
                                <label for="inp" className="inp" ref={refLabelNumeroCartao}>
                                <input type="text" placeholder="&nbsp;" maxLength={19} {...register("card_number")} ref={(el) => {refNumeroCartao.current = el; register("card_number").ref(el);}} onClick={() => clearError(refNumeroCartao, refLabelNumeroCartao, refErrorNumeroCartao, error, setError)} onChange={(e) => {if (error === "0") {setValue("card_number", maskcartao(e.target.value));} else {clearError(refNumeroCartao, refLabelNumeroCartao, refErrorNumeroCartao, error, setError);}}}></input>
                                <span className="label">Número do Cartão</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="billing_box_card1b"></div>
                            <div className="billing_box_card1c">
                                <label for="inp" className="inp" ref={refLabelVencimentoCartao}>
                                <input type="text" placeholder="&nbsp;" maxLength={5} {...register("card_expiry")} ref={(el) => {refVencimentoCartao.current = el; register("card_expiry").ref(el);}} onClick={() => clearError(refVencimentoCartao, refLabelVencimentoCartao, refErrorNumeroCartao, error, setError)} onChange={(e) => {if (error === "0") {setValue("card_expiry", maskvencimento(e.target.value));} else {clearError(refVencimentoCartao, refLabelVencimentoCartao, refErrorNumeroCartao, error, setError);}}}></input>
                                <span className="label">Validade do Cartão</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>                            
                        </div>
                        <span className="space_form"></span>

                        <span ref={refErrorNomeCartao} className="error_form"></span>
                        <div className="billing_box_card">
                            <div className="billing_box_card1a">
                                <label for="inp" className="inp" ref={refLabelNomeCartao}>
                                <input type="text" placeholder="&nbsp;" maxLength={60} {...register("card_name")} ref={(el) => {refNomeCartao.current = el; register("card_name").ref(el);}} onClick={() => clearError(refNomeCartao, refLabelNomeCartao, refErrorNomeCartao, error, setError)} onChange={() => clearError(refNomeCartao, refLabelNomeCartao, refErrorNomeCartao, error, setError)}></input>
                                <span className="label">Nome Impresso no Cartão</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="billing_box_card1b"></div>
                            <div className="billing_box_card1c">
                                <label for="inp" className="inp" ref={refLabelCodigoCartao}>
                                <input type="text" placeholder="&nbsp;" maxLength={3} {...register("card_code")} ref={(el) => {refCodigoCartao.current = el; register("card_code").ref(el);}} onClick={() => clearError(refCodigoCartao, refLabelCodigoCartao, refErrorNomeCartao, error, setError)} onChange={() => clearError(refCodigoCartao, refLabelCodigoCartao, refErrorNomeCartao, error, setError)}></input>
                                <span className="label">Cód de Segurança</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>                            
                        </div>
                        <span className="space_form"></span>
                        <span className="billing_alert_card">A assinatura é mensal, a cada mês será lançado automaticamente o valor do plano que você escolheu na fatura do seu cartão de crédito. Você poderá cancelar a assinatura a qualquer momento.</span>

                        <span className="space_form"></span>
                        <span ref={refErrorCartao} className="error_form"></span>
                        <span className="space_form"></span>
                        
                        <div className="billing_box_card">
                            <div className="billing_box_card1c"><button type="button" name="bt4a" className={isPaying ? "button_disabled_form" : "button2_form"} onClick={() => setStep(0)} disabled={isPaying}>VOLTAR</button></div>
                            <div className="billing_box_card1b"></div>
                            <div className="billing_box_card1a"><button type="button" name="bt4b" ref={refButtonCartao} className={isPaying ? "button_disabled_form" : "button_form"} onClick={create_payment_card} disabled={isPaying}>FAZER PAGAMENTO</button></div>
                        </div>

                    </form>
                </div>
                </>
                )}


                {/* tela para a alteração da forma de pagamento: cartão -> pix/boleto ou pix/boleto -> cartão - somente agentes status 4 (assinantes) */}
                { step === 5 && (
                <>
                <span className="ft_topico">Alterar pagamento</span>
                <span className="ft_descricao">Altere a forma de pagamento de acordo com sua maior comodidade.</span>

                <div className="space"></div>
                <img className="billing_desenvolvimento_image" src={image_desenvolvimento}></img>
                <div className="space"></div>

                <span className="billing_success_02">Essa funcionalidade está em construção, em breve estará finalizada para que você possa explorar ainda mais recursos da plataforma.</span>

                {/*
                <div className="border_form billing_border_form2">
                    <form className="form">

                        <span className="title_form">Altera a forma de pagamento</span>
                        <span className="subtitle_form">Alterando a forma de pagamento, suas próximas mensalidades serão geradas na opção escolhida.</span>
                        <span className="space_form"></span>
                
                        <div className="billing_box_plans">
                            <span className="billing_box_payment_title">Pagamentos Disponíveis:</span>
                            <div className="billing_box_payment_group">
                                { historyPayment.parcelas[historyPayment.parcelas.length - 1].tipo === "PIX" || historyPayment.parcelas[historyPayment.parcelas.length - 1].tipo === "BOLETO" ? 
                                (<>
                                <div className="billing_box_payment2">
                                    <div className="billing_box_payment_item">
                                        <div className="billing_box_payment_item_option">
                                            <input type="radio" name="payment" value="credito" className="radio_custom" checked={payment === "credito"} onChange={handleChange}></input>
                                            <span className="billing_box_payment_item_text">Cartão de Crédito</span>
                                        </div>
                                        <div className="billing_box_payment_item_image"><img className="billing_image_payment" src={image_cartao}></img></div>
                                    </div>
                                </div>
                                </>) : 
                                (<>
                                <div className="billing_box_payment2">
                                    <div className="billing_box_payment_item">
                                        <div className="billing_box_payment_item_option">
                                            <input type="radio" name="payment" value="pix" className="radio_custom" checked={payment === "pix"} onChange={handleChange}></input>
                                            <span className="billing_box_payment_item_text">Pix</span>
                                        </div>
                                        <div className="billing_box_payment_item_image"><img className="billing_image_payment" src={image_pix}></img></div>
                                    </div>
                                </div>                                
                                </>)}
                                
                                <div className="billing_box_space"><span className="billing_box_space_line"></span></div>
                                
                                { historyPayment.parcelas[historyPayment.parcelas.length - 1].tipo === "PIX" || historyPayment.parcelas[historyPayment.parcelas.length - 1].tipo === "CREDIT_CARD" ? 
                                (<>
                                <div className="billing_box_payment2">
                                    <div className="billing_box_payment_item">
                                        <div className="billing_box_payment_item_option">
                                            <input type="radio" name="payment" value="boleto" className="radio_custom" checked={payment === "boleto"} onChange={handleChange}></input>
                                            <span className="billing_box_payment_item_text">Boleto</span>
                                        </div>
                                        <div className="billing_box_payment_item_image"><img className="billing_image_payment" src={image_boleto}></img></div>
                                    </div>
                                </div>
                                </>) : 
                                (<>
                                <div className="billing_box_payment2">
                                    <div className="billing_box_payment_item">
                                        <div className="billing_box_payment_item_option">
                                            <input type="radio" name="payment" value="pix" className="radio_custom" checked={payment === "pix"} onChange={handleChange}></input>
                                            <span className="billing_box_payment_item_text">Pix</span>
                                        </div>
                                        <div className="billing_box_payment_item_image"><img className="billing_image_payment" src={image_pix}></img></div>
                                    </div>
                                </div>                                
                                </>)}
                            
                            </div>
                        </div>

                        <span className="space_form"></span>
                        <span ref={refError} className="error_form"></span>
                        <span className="space_form"></span>

                        <button type="button" name="bt5" ref={refButton} className={isPaying ? "button_disabled_form" : "button_form"} onClick={create_payment} disabled={isPaying}>ALTERAR</button>

                    </form>
                </div>
                */}

                
                </>
                )}

                <div className="space"></div>
                <div className="space"></div>
                <div className="button_back_form"><button type="button" name="btbck" className="button2_form" onClick={() => navigate("/panel")}>VOLTAR</button></div>
                <div className="space"></div>
                <div className="space"></div>

            </div>

            <Footer access={1}></Footer>
        
        </div>

    )
}
